import {HeaderContainer} from "@/components/headers";
import {Footer} from "@/components";
import {MainLinks} from "@/components/main-links";
import {ContactAdvantages, ContactWithPol, PolSupport} from "@/components/contact-us-page";
import {DataSpreader} from "@/layouts";
import {errorRedirectHandler, fetchData, isEmpty} from "@/utils/global-functions";
import {REQ_TYPES} from "@/constants/general-constants";
import Head from "next/head";
import parse from "html-react-parser";

export default function ContactUs({data = {}}) {

    const {meta} = data && !isEmpty(data.data) && !isEmpty(data.data.data) ? data.data.data : {};

    return (
        <>
            <Head>
                <title>پل دیزاینرز | تماس با ما</title>
                {
                    meta ? parse(meta) : null
                }
            </Head>

            <DataSpreader data={data}>
                <HeaderContainer/>

                <ContactWithPol/>

                <ContactAdvantages/>

                <PolSupport/>

                <section className="container mt-[3.125rem] mb-16 lg:mb-[6.75rem]">
                    <MainLinks/>
                </section>

                <Footer/>
            </DataSpreader>
        </>
    )
}

export async function getServerSideProps() {

    const data = await fetchData("contact", REQ_TYPES.GET);

    return {
        ...errorRedirectHandler(data.error),
        props: {data}
    }
}
